// extracted by mini-css-extract-plugin
export var belowButtonText = "style-mod--below-button-text--01ec7";
export var box = "style-mod--box--e7699";
export var buttonTitle = "style-mod--button-title--dca25";
export var coloredText = "style-mod--colored-text--f1532";
export var consentCheckbox = "style-mod--consent-checkbox--65615";
export var consentContainer = "style-mod--consent-container--591fb";
export var email = "style-mod--email--98698";
export var emailInput = "style-mod--email-input--1012d";
export var emailSubmit = "style-mod--email-submit--04949";
export var errorMessage = "style-mod--error-message--3f375";
export var inputChecked = "style-mod--input-checked--b3726";
export var nameInput = "style-mod--name-input--881b3";
export var newSubscribeInput = "style-mod--new-subscribe-input--2b38a";
export var newSubscribeInputForm = "style-mod--new-subscribe-input-form--00efa";
export var newSubscribeInputMail = "style-mod--new-subscribe-input-mail--b68fe";
export var newSubscribeInputText = "style-mod--new-subscribe-input-text--11777";
export var newSubtitle = "style-mod--new-subtitle--199ef";
export var subheadline = "style-mod--subheadline--9bfce";
export var submitBtn = "style-mod--submit-btn--2c186";
export var subscribeForm = "style-mod--subscribe-form--0f5ec";
export var subscribeInput = "style-mod--subscribe-input--5eeb3";
export var subscribeInputForm = "style-mod--subscribe-input-form--24f49";
export var subscribeInputMail = "style-mod--subscribe-input-mail--53707";
export var subscribeInputText = "style-mod--subscribe-input-text--97c7c";
export var subtitle = "style-mod--subtitle--43190";
export var successMsg = "style-mod--success-msg--d2e26";
export var termsAndConditions = "style-mod--terms-and-conditions--4b056";
export var termsCheckbox = "style-mod--terms-checkbox--8d421";
export var text = "style-mod--text--4514d";
export var whiteIcon = "style-mod--white-icon--fb6f9";